module.exports = __webpack_public_path__ + "img/pro_three_2.5b3693c7.jpg";